import React, { Dispatch, Fragment, SetStateAction } from 'react';
import { FirstLanding } from '@hooks/firstLanding';
import { AGE_ANTISPOOFING_CONFIG_KEY } from '@utils/constants/storage';
import { SubtextColor } from '@components/commons';
import GuidePanel from '@components/guide';
import { Props as GlobalContextProps } from '@/globalContext';

interface Props {
    firstLandingConfig: FirstLanding;
    isCollector: boolean;
    set: Dispatch<SetStateAction<GlobalContextProps>>;
}

const getGuidePanelChildren = (isCollector: boolean) => {
    const result: JSX.Element[] = [];
    if (isCollector) {
        result.push(
            <Fragment key={'collector'}>
                Select the collection values in the collector tab.
            </Fragment>,
        );
    }
    result.push(
        <Fragment key={'config'}>
            Select the desired endpoint at the settings tab.
            <SubtextColor>(Default is Antispoofing)</SubtextColor>
        </Fragment>,
    );
    result.push(<Fragment key={'scan'}>Go to the Scan tab and follow the instructions.</Fragment>);

    return result;
};

const Guide: React.FC<Props> = ({ isCollector, firstLandingConfig, set }) => {
    return (
        <GuidePanel
            section={AGE_ANTISPOOFING_CONFIG_KEY}
            firstLandingConfig={firstLandingConfig}
            set={set}
        >
            {getGuidePanelChildren(isCollector)}
        </GuidePanel>
    );
};

export default Guide;
